
import React from 'react';

const PlatformLogo = () => {
  return (
    <div className="flex items-center justify-center mb-8">
      <div className="flex items-center space-x-3">
        <div className="relative">
          <img 
            src="/large_logo.png" 
            alt="VITL Logo" 
            className="h-12 object-contain"
          />
        </div>
      </div>
    </div>
  );
};

export default PlatformLogo;
